import { render, staticRenderFns } from "./legendBox11.vue?vue&type=template&id=02fbed0e&scoped=true&"
import script from "./legendBox11.vue?vue&type=script&lang=js&"
export * from "./legendBox11.vue?vue&type=script&lang=js&"
import style0 from "./legendBox11.vue?vue&type=style&index=0&id=02fbed0e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02fbed0e",
  null
  
)

export default component.exports